import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from './LocaleProvider';

// O endereço só existe no navegador: no HTML estático ele não aparece como texto,
// e a ofuscação de e-mail da Cloudflare não cria links /cdn-cgi/ quebrados.
export default function ContactEmail({ className }) {
  const { locale } = useLocale();
  const [address, setAddress] = useState(null);
  useEffect(() => {
    setAddress(['doc', 'eidoc.com.br'].join('@'));
  }, []);
  if (!address) return <Link to={locale === 'es' ? '/es/ayuda' : '/suporte'} className={className}>{locale === 'es' ? 'Ayuda y contacto' : 'Suporte e contato'}</Link>;
  return <a href={`mailto:${address}`} className={className}>{address}</a>;
}
